<template>
  <div class="container-fluid">
    <div class="row d-flex justify-content-center">
      <div class="col-lg-10">
        <h1 class="heading-color text-center p-5">{{photoName}} Photos</h1>
      </div>
    </div>
    <div class="row d-flex justify-content-center" v-if="this.$store.getters.apiStatus !== 'loading'">
      <div class="col-lg-10">
        <div class="overlay">
          <div class="main-loader">
            <MainLoader></MainLoader>
          </div>
        </div>
        <div class="row" v-if="this.photoImages.length">
          <ItemCard v-for="photoImage in photoImages" :key="photoImage.id" :item="photoImage" :nextLink="'/download/photo_image/' + photoImage.id"></ItemCard>
        </div>
        <div class="not-found-div" v-else>
          <div class="row">
            <div class="col-md-12">
              <p class="text-center">No photo images found in {{photoName}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-loader" v-else>
      <MainLoader></MainLoader>
    </div>
  </div>
</template>

<script>
import ItemCard from '@/components/ItemCard'
export default {
  name: 'PhotoImages',
  components: {
    ItemCard
  },
  data () {
    return {
      photoImages: [],
      photoName: ''
    }
  },
  mounted () {
    this.fetchPhotoImages()
  },
  methods: {
    fetchPhotoImages () {
      this.photoImages = []
      $('.overlay').removeClass('d-none')
      this.$store.dispatch('fetchPhotoImages', { photoID: this.$route.params.photo_id, category: this.$route.params.category_name })
        .then((result) => {
          this.photoImages = result.data.images
          $('.overlay').addClass('d-none')
          this.photoName = result.data.photo_name
          document.title = 'Img-Lib - ' + this.photoName + ' photo images'
        })
        .catch((err) => this.$helper.catchHandler(err))
    }
  }
}

</script>

<style scoped>
.not-found-div {
  height: calc(70vh - 190px);
}
@media screen and (max-width: 500px){
  .not-found-div {
    height: calc(70vh - 100px);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/PhotoImages.vue